import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';
import { useBreadcrumbs } from '@/modules/core/hooks';
import {
  ExpressSetupWizardStepTitle,
  ExpressSetupWizardStepType,
} from '@/modules/ExpressSetup/ExpressSetup.types.ts';
import RenewalSetup from '@/modules/Renewals/RenewalSetup/RenewalSetup';

const RenewalSetupPage = () => {
  const { id } = useParams<{ id: string }>();
  const { hash } = useHistory();

  const title = useMemo(() => {
    switch (hash) {
      case ExpressSetupWizardStepType.MainContact:
        return ExpressSetupWizardStepTitle.main_contact;
      case ExpressSetupWizardStepType.BankAccount:
        return ExpressSetupWizardStepTitle.bank_account;
      case ExpressSetupWizardStepType.Plans:
        return ExpressSetupWizardStepTitle.plans;
      default:
        return ExpressSetupWizardStepTitle.main_contact;
    }
  }, [hash]);

  useBreadcrumbs(
    [
      {
        title: 'Renewals',
        route: ROUTES.RENEWALS_SETUP_BY_PLAN_YEAR_ID(id),
      },
    ],
    [title],
    undefined,
    true
  );

  return <RenewalSetup />;
};

export default RenewalSetupPage;
